import { DashboardLayout } from '../../Layout/DashboardLayout'
import { Tab, Tabs } from "react-bootstrap";
import ScofaAppCards from './ScofaAppCards';

import DashboardLinkManagement from '../../Screens/ScofaManagement/DashboardLink';

const ScofaAppDashboard = () => {



    return (
        <DashboardLayout>

            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-12">
                        <Tabs
                            defaultActiveKey="article"
                            id="uncontrolled-tab-example3"
                            className="customTabs mb-4"
                        >
                            <Tab eventKey="article" title="Articles">
                                <ScofaAppCards module="articles" />
                            </Tab>
                            <Tab eventKey="featured" title="Featured Mixes">
                                <ScofaAppCards module="soundsmixture" />
                            </Tab>
                            <Tab eventKey="dashboard-links" title="Products Links">
                                <DashboardLinkManagement />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default ScofaAppDashboard